module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-1450.8bbc9393.svg";